"use strict";
exports.__esModule = true;
exports.MANUAL_PAY_PAYMENT_SCHEDULE = void 0;
var common_1 = require("../../common");
exports.MANUAL_PAY_PAYMENT_SCHEDULE = {
    HEADER: 'Review payment schedule',
    BODY: 'To have Flex pay ${{payment}} to your property, here’s how you’ll pay Flex.',
    LIST_HEADER: 'Each month',
    FIRST_PAYMENT: '1st payment',
    FIRST_PAYMENT_INFO: 'Today',
    SECOND_PAYMENT: '2nd payment',
    FEE_DISCLAIMER: common_1.FEE_DISCLAIMER.DEFAULT,
    CHANGE_SCHEDULE: 'Adjust schedule',
    CTA: 'Accept'
};
